import React from "react";
import coming from "./images/coming.jpg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <img className="default" src={coming} alt="sup" />
    </div>
  );
}

export default App;
